
import { Link } from 'react-router-dom';

export default function ProgramsSection() {
  const programs = [
    {
      title: 'Little Kickers (U6)',
      age: 'Ages 3-5',
      description: 'Fun-focused introduction to soccer with basic skills development and social interaction.',
      features: ['Basic ball control', 'Fun games & activities', 'Social skills development', 'Parent participation welcome'],
      icon: 'ri-football-line',
      color: 'bg-purple-100 text-purple-600'
    },
    {
      title: 'Rising Stars (U10)',
      age: 'Ages 6-9',
      description: 'Skill building program focusing on fundamental techniques and teamwork.',
      features: ['Technical skills training', 'Small-sided games', 'Teamwork emphasis', 'Character development'],
      icon: 'ri-star-line',
      color: 'bg-purple-200 text-purple-700'
    },
    {
      title: 'Elite Academy (U14)',
      age: 'Ages 10-13',
      description: 'Competitive training program for serious young players looking to excel.',
      features: ['Advanced techniques', 'Tactical understanding', 'Competitive matches', 'Leadership skills'],
      icon: 'ri-trophy-line',
      color: 'bg-purple-300 text-purple-800'
    },
    {
      title: 'Premier League (U18)',
      age: 'Ages 14-17',
      description: 'High-level training preparing players for college and beyond.',
      features: ['Professional coaching', 'College prep support', 'Advanced tactics', 'Mental conditioning'],
      icon: 'ri-medal-line',
      color: 'bg-purple-400 text-purple-900'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Programs</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Age-appropriate professional training programs designed to develop skills, character, and a lifelong love for soccer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {programs.map((program, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="p-6">
                <div className={`w-16 h-16 ${program.color} rounded-full flex items-center justify-center mb-4`}>
                  <i className={`${program.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{program.title}</h3>
                <p className="text-purple-600 font-semibold mb-3">{program.age}</p>
                <p className="text-gray-600 mb-4">{program.description}</p>
                <ul className="space-y-2 mb-6">
                  {program.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-purple-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/programs"
                  className="block w-full bg-purple-600 text-white py-2 px-4 rounded-lg hover:bg-purple-700 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
                >
                  Learn More
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/programs"
            className="inline-flex items-center bg-purple-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-purple-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            View All Programs
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
